import classNames from 'classnames';
import NumberComponent from 'modules/common/components/Number';
import usePublicRuntimeConfig from 'modules/common/hooks/usePublicRuntimeConfig';
import Link from 'next/link';
import React from 'react';
// import NumberComponent, { formatCurrency } from 'modules/common/components/Number';
// import { useRouter } from 'next/router';

type HowDoesItWorkProps = {
  platformFees: number;
  bountyStart: number;
  bountyConfirm: number;
  mySearch?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

const HowDoesItWork: React.FC<HowDoesItWorkProps> = ({ children, mySearch, className, bountyStart, bountyConfirm, platformFees, ...props }) => {
  // const router = useRouter();
  const { siteName } = usePublicRuntimeConfig();

  return (
    <div className={classNames('max-w-xs', className)} {...props}>
      {mySearch ? (
        <>
          <p>Vous recevez les coordonnées de candidats recommandés par d’autres consultants.</p>
          <p className="mt-2">
            Si vous, ou l’un de vos collaborateurs, placez le candidat chez un client, pour cette mission ou une autre mission, vous devrez verser la
            prime selon les modalités définies.
          </p>
          <p className="mt-2">Headlinker se charge de la facturation et des paiements.</p>

          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            {bountyStart && (
              <div className="mt-1 text-left">
                <ul>
                  <p className="ml-3">
                    + la commission HL de{' '}
                    <strong>
                      {formatCurrency({ value: bountyStart * platformFees, locale: router.locale, precision: 2 })} (
                      <NumberComponent percent value={platformFees} />)
                    </strong>
                  </p>
                  <p className="ml-3">
                    Total de <strong>{formatCurrency({ value: bountyStart * (1 + platformFees), locale: router.locale, precision: 2 })} </strong>
                  </p>
                </ul>
              </div>
            )}
          </div> */}
        </>
      ) : (
        <>
          <p>Tu recommandes un candidat en transmettant ses coordonnées au consultant en charge de cette mission.</p>
          <p className="mt-2">
            Si ton candidat est recruté/placé par le consultant ou l’un de ses collaborateurs, pour cette mission ou une autre mission, tu toucheras
            la prime selon les modalités définies. Pour cela, {siteName} éditera un appel à facture pour que tu te fasses payer directement par le
            consultant. Tu recevras aussi une facture de {siteName} pour les <NumberComponent percent value={platformFees} /> de frais.
          </p>
          <p className="mt-12">
            💡 Savais-tu que tu pouvais bénéficier de 0 frais et bien d’autres avantages en souscrivant à{' '}
            <Link className="text-primary underline" href="/user/subscription">
              l’offre Pro
            </Link>
          </p>
        </>
      )}
    </div>
  );
};

export default HowDoesItWork;
